import Vue from 'vue';
import App from './App';
import router from './router';
import vueHeadful from 'vue-headful';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Datepicker from 'vuejs-datepicker';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueCookie from 'vue-cookie';
import VueScrollTo from 'vue-scrollto';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueYoutube from 'vue-youtube';
import 'swiper/dist/css/swiper.css';
import MarqueeText from 'vue-marquee-text-component';
import Dropdown from "@/weact/components/Dropdown";
import SingleUpload from "@/weact/components/SingleUpload";
import Default from '@/layouts/Default';
import Blank from '@/layouts/Blank';
import WeACTCore from '@/weact/WeACTCore.js';
import PPlusCore from '@/resources/PPlusCore.js';
import PPlusModal from '@/resources/PPlusModal.js';
import '@/layouts/scss/Main.scss';

library.add(fas, fab);

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(VueCookie);
Vue.use(VueScrollTo);
Vue.use(VueAwesomeSwiper);
Vue.use(VueReCaptcha, { siteKey: '6LeErdIUAAAAAHmEPmQxW3RodgQHr_qDjycWsAsM' });
Vue.use(VueYoutube);
Vue.use(WeACTCore);
Vue.use(PPlusCore);
Vue.use(PPlusModal);

Vue.component('date-picker', Datepicker);
Vue.component('vue-headful', vueHeadful);
Vue.component('marquee-text', MarqueeText);
Vue.component('we-dropdown', Dropdown);
Vue.component('we-single-upload', SingleUpload);
Vue.component('default-layout', Default);
Vue.component('blank-layout', Blank);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');